import React from "react";
import type { BaseIconProps } from "./baseIcon";

export const VaultsIcon = React.forwardRef<SVGSVGElement, BaseIconProps>(
  (props, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="currentColor"
        focusable={false}
        ref={ref}
        {...props}
      >
        <path d="M13.333 3.33334C13.333 2.96515 13.0345 2.66668 12.6663 2.66668H3.33301C2.96482 2.66668 2.66634 2.96515 2.66634 3.33334V9.33334C2.66634 9.70153 2.96482 10 3.33301 10H12.6663C13.0345 10 13.333 9.70153 13.333 9.33334V3.33334ZM14.6663 9.33334C14.6663 10.4379 13.7709 11.3333 12.6663 11.3333H3.33301C2.22844 11.3333 1.33301 10.4379 1.33301 9.33334V3.33334C1.33301 2.22877 2.22844 1.33334 3.33301 1.33334H12.6663C13.7709 1.33334 14.6663 2.22877 14.6663 3.33334V9.33334Z" />
        <path d="M4.66699 13.3333C4.66699 12.9651 4.96547 12.6667 5.33366 12.6667H10.667C11.0352 12.6667 11.3337 12.9651 11.3337 13.3333C11.3337 13.7015 11.0352 14 10.667 14H5.33366C4.96547 14 4.66699 13.7015 4.66699 13.3333Z" />
        <path d="M10.1859 4.20509C10.4408 3.93953 10.8629 3.93072 11.1286 4.18556C11.3941 4.44049 11.4029 4.86265 11.1481 5.12827L8.48143 7.90626C8.35571 8.03721 8.18184 8.11134 8.00031 8.11134C7.81878 8.11134 7.6449 8.03721 7.51919 7.90626L6.93325 7.29558L5.81476 8.4616C5.55982 8.72716 5.13767 8.73597 4.87205 8.48113C4.60649 8.2262 4.59768 7.80404 4.85252 7.53842L6.45278 5.87176L6.50226 5.82553C6.6222 5.72363 6.77506 5.66668 6.9339 5.66668C7.11531 5.66675 7.28872 5.74089 7.41437 5.87176L7.99965 6.48178L10.1859 4.20509Z" />
      </svg>
    );
  },
);

if (process.env.NODE_ENV !== "production") {
  VaultsIcon.displayName = "VaultsIcon";
}
